var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectMaskProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 397,
    viewBox: "0 0 494 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.12109,
    y: 1.10962,
    width: 491.481,
    height: 394.546,
    stroke: "#164F68",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.694 294.159L245.681 198.369H248.028L248.042 294.159H245.694Z",
    fill: "#598599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.077 199.65L151.075 197.303L246.706 197.22L246.708 199.566L151.077 199.65Z",
    fill: "#598599"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.581 249.762L195.604 243.798L243.875 195.408L249.853 201.372L201.581 249.762Z",
    fill: "#00405B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.725 199.17L246.063 197.512L294.045 149.415L295.706 151.072L247.725 199.17Z",
    fill: "#598599"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342.648 202.621H242.637L242.646 102.606L251.089 102.607L251.082 194.176H342.648V202.621Z",
    fill: "#00405B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectMaskProfile);
export default __webpack_public_path__ + "static/media/object_mask_profile.8d13e9f3c26d4e6320150e443d5a72a7.svg";
export { ForwardRef as ReactComponent };